import React from "react";
const CallNumberAndHours = () => <p className="to-see-price noborder mb-2" data-sentry-component="CallNumberAndHours" data-sentry-source-file="CallNumberAndHours.tsx">
    Call 717-392-7472
    <em>
      (Mon - Fri 8AM - 8PM EST
      <br />
      Sat &amp; Sun: 9am - 4pm EST)
    </em>
  </p>;
export default CallNumberAndHours;